// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { TipoArticuloProps } from '../../../interfaces/tipoArticulo.ts'
import { TipoArticuloApiInputProps } from '../interfaces'
import { tipoArticuloFragment } from '../interfaces/fragment.ts'

const gqlQuery = gql`
  ${tipoArticuloFragment}
  mutation TIPO_ARTICULO_REGISTRO($codigo: String!, $input: TipoArticuloInput!) {
    tipoArticuloRegistro(codigo: $codigo, input: $input) {
      ...tipoArticuloFragment
    }
  }
`

/**
 * Registramos un nuevo tipo de articulo
 * @param input
 */
export const apiTipoArticuloRegistro = async (
  input: TipoArticuloApiInputProps,
): Promise<TipoArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(gqlQuery, input)
    return data.tipoArticuloRegistro
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
